if (typeof module != 'undefined' && typeof require == 'function') {
    module.exports = require('./fitt.js');
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt/index.js
// module id = 425
// module chunks = 0